import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const HalfCardWrapper = styled.div(({ theme }) => ({
    margin: `${theme.spacing.medium} 0`,
}));

export const Heading = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Highest_Emphasis,
    marginBottom: theme.spacing.small,
}));

export const SubHeading = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Med_Emphasis,
}));

export const SubHeadingWrapper = styled.div(({ theme }) => ({
    display: "flex",
    gap: theme.spacing.xxSmall,
    alignItems: "center",
    marginBottom: theme.spacing.xSmall,
}));

export const ButtonContainer = styled.div(({ theme }) => ({
    marginTop: theme.spacing.xLarge,
    width: "100%",
}));
